module.exports = __webpack_public_path__ + "img/tick.c31023fa.svg";